// This is not to be confused with redux actions.
const PAYSTACK_ADD_CARD = 'PAYSTACK_ADD_CARD';
const PAYSTACK_TOKENIZE_AMOUNT = '10000';
const PAYSTACK_CHARGE_CARD_FOR_INVESTMENT =
  'PAYSTACK_CHARGE_CARD_FOR_INVESTMENT';

export {
  PAYSTACK_ADD_CARD,
  PAYSTACK_TOKENIZE_AMOUNT,
  PAYSTACK_CHARGE_CARD_FOR_INVESTMENT,
};
